import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import {
    chain,
    LoadCart as baseLoadCart,
    UpdateCart as baseUpdateCart,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateCart";
import ga from "@store/Framework/Common/GoogleAnalytics";
import {
    addToChainAfter,
    createChainHandler,
    executeAwaitableHandlerChain,
    replaceInChain,
} from "@store/Modules/client-framework/HandlerCreator";

export const TrackShippingInfoOnSubmit = createChainHandler("TrackShippingInfoOnSubmit", chain, props => {
    ga.track.addShippingInfo({ items: props.cart.cartLines ?? undefined }, { cart: props.cart });
});

addToChainAfter(chain, baseUpdateCart, TrackShippingInfoOnSubmit);

export const LoadCart = createChainHandler("LoadCart", chain, async props => {
    const state = props.getState();
    const { cartId } = state.pages.checkoutShipping;
    if (cartId) {
        await executeAwaitableHandlerChain<Parameters<typeof loadCart>[0], ReturnType<ReturnType<typeof loadCart>>>(
            loadCart,
            { cartId },
            props,
        );
    } else {
        await executeAwaitableHandlerChain<
            Required<Parameters<typeof loadCurrentCart>>[0],
            ReturnType<ReturnType<typeof loadCurrentCart>>
        >(loadCurrentCart, { getPromotions: true }, props);
    }
});

replaceInChain(chain, baseLoadCart, LoadCart);
